export const data = [
    {'name': 'Slime Potion', 'description': 'Apply to any target to immediately increase its slimyness.', 'requirements': [{ 'type': 0 }, { 'type': 1 }, { 'type': 1 }, ], 'price': [30,70,100,200], 'time': 5, 'instructions': 'Stir in slimes one at a time, then allow to cook for <b>5s</b>.', 'icon': 'slime'},
    
    
    
    
    {'name': 'Potion of Lesser Healing', 'description': 'Magically cures small cuts and scrapes.', 'requirements': [{ 'type': 1 }, { 'type': 2 }, { 'type': 7 }, ], 'price': [50,100,150,300], 'time': 10, 'instructions': 'Combine all ingredients while stirring intermittently. Simmer <b>10s</b>.', 'icon': 'healing'},
    
    
    
    
    {'name': 'Potion of Greater Healing', 'description': 'Guaranteed to make you feel great.', 'requirements': [{ 'type': 1 }, { 'type': 6 }, { 'type': 8 }, ], 'price': [80,120,180,360], 'time': 15, 'instructions': 'Combine all ingredients while stirring continuously. Simmer <b>15s</b>.', 'icon': 'greater_healing'},
    
    
    
    
    {'name': 'Giant Strength Potion', 'description': 'Seems useful for adventures, but the bottle is way too big to carry.', 'requirements': [{ 'type': 0 }, { 'type': 3 }, { 'type': 5 }, ], 'price': [50,150,250,500], 'time': 20, 'instructions': 'Mix vigorously until a consistent texture is achieved, up to <b>20s</b>.', 'icon': 'giant_strength'},
    
    
    
    
    {'name': 'Cat Potion', 'description': 'Meow meow meow meow, meow meow meow.', 'requirements': [{ 'type': 5 }, { 'type': 4 }, { 'type': 9, 'ingredient': '9th Life' }, ], 'price': [140,180,220,440], 'time': 15, 'instructions': 'Meow meow meow meow, meow meow meow, meow <b>15s</b> meow.', 'icon': 'cat'},
    
    
    
    
    {'name': 'Love Potion', 'description': 'Side effects include pining and heatbreak.', 'requirements': [{ 'type': 4 }, { 'type': 2 }, { 'type': 8 }, ], 'price': [100,160,200,400], 'time': 20, 'instructions': 'Combine ingredients and simmer over a slow-burning flame for <b>20s</b>.', 'icon': 'love'},
    
    
    
    
    {'name': 'Fondue', 'description': 'For customers who walked into the wrong shop.', 'requirements': [{ 'type': 0 }, { 'type': 6 }, { 'type': 6 }, ], 'price': [45,70,100,200], 'time': 30, 'instructions': 'Add cheese in small handfuls, stirring constantly. Total time: <b>30s</b>.', 'icon': 'fondue'},
    
    
    
    
    {'name': 'Potion of Invisibility', 'description': 'Most useful for those trying to be sneaky, or the very shy.', 'requirements': [{ 'type': 1 }, { 'type': 7 }, { 'type': 5 }, ], 'price': [80,150,250,500], 'time': 20, 'instructions': 'Alternate clockwise and counterclockwise stirring for <b>20s</b>.', 'icon': 'invisibility'},
    
    
    
    
    
    {'name': 'Potion of Game Development', 'description': 'Drink this to level up your skills for the next 48 hours.', 'requirements': [{ 'type': 9, 'ingredient': 'Game jam' }, { 'type': 7 }, { 'type': 8 }, ], 'price': [200,200,200,600], 'time': 24, 'instructions': 'Maintain focus to the exclusion of all else. Takes <b>24s</b>.', 'icon': 'game_dev'},
    
    
    
    
    {'name': 'Magnificent Potion', 'description': 'Grants legendary abilities to those rich enough to afford it.', 'requirements': [{ 'type': 9, 'ingredient': 'Crystal of Power' }, { 'type': 9, 'ingredient': 'Essence of Vitality' }, { 'type': 3 }, ], 'price': [600,650,700,1400], 'time': 30, 'instructions': 'Mix ingredients very, very, very carefully, then boil for <b>30s</b>.', 'icon': 'rainbow'},
    
    
    
    
    ];